import api from './api';

export async function getTransactions({
  page = 1,
  limit = 20,
  type,
  status,
  platform,
  search,
  userId,
  startDate,
  endDate,
  sort = 'newest',
} = {}) {
  const params = { page, limit, sort };

  if (type) params.type = type;
  if (status) params.status = status;
  if (platform) params.platform = platform;
  if (search) params.search = search;
  if (userId) params.userId = userId;
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;

  const response = await api.get('/admin/transactions', { params });
  return response.data;
}

export async function getTransactionById(purchaseId) {
  const response = await api.get(`/admin/transactions/${purchaseId}`);
  return response.data;
}

export async function getPetalTransactions({
  page = 1,
  limit = 20,
  search,
  type,
  direction,
  userId,
  from,
  to,
} = {}) {
  const params = { page, limit };

  if (search) params.search = search;
  if (type) params.type = type;
  if (direction) params.direction = direction;
  if (userId) params.userId = userId;
  if (from) params.from = from;
  if (to) params.to = to;

  const response = await api.get('/admin/petal-transactions', { params });
  return response.data;
}
